import React, { Component } from 'react';
import FakeData from '.././fake-data';
import { Link } from 'react-router-dom';

import Geosuggest from 'react-geosuggest';

import './Teams.css';
import { Modal, ComboBox, PublicityPicker, PhonePicker, ConfirmModal, ItemPicker } from './Common';
import Avatar from './Avatar'
import { AddTeamWithSquads } from '.././pages/CreatePages/ClubInit'

export default class Teams extends Component {
    constructor(p) {
        super(p)
        this.state = {
            activeTab: "Current Teams",
            currentFilter: "",
            yearFilter: "",
            userTabs: ["Current Teams", "Past Teams"],
            isAddingCurrentTeams: false,
            isManagingCurrent: false,
            isAddingPastTeams: false,
            isManagingPast: false,
            isInvitingTeams: false,
        }
    }

    getSportNames = () => {
        const list = [];
        this.props.sports.forEach((item, i) => {
            list.push(item.name)
        });

        return list;
    }

    getYears = () => {
        const list = [];
        const d = new Date();
        for (let x = d.getFullYear(); x >= (d.getFullYear() - 5); x--) {
            if (x === (d.getFullYear() - 5)) {
                list.push(x + " and before")
            } else {
                list.push(x)
            }
        }

        return list;
    }

    componentWillReceiveProps(nextProps) {
        const { past, current } = nextProps.teams
        this.setState({
            isManagingCurrent: (current.length === 0) ? false : this.state.isManagingCurrent,
            isManagingPast: (past.length === 0) ? false : this.state.isManagingPast
        });
    }

    onTeamAdd(obj, cb) {
        const { address, location, manager, postal, secretary, state, suburb, country, id, level } = this.props.content
        const _team = {
            name: obj.name,
            level: level,
            sport: obj.sport,
            id: null,
            hash: null,
            clubId: id,
            isClub: (this.props.contentType === "C") ? true : false,
            email: obj.email,
            phone: obj.phone,
            land: obj.land,
            website: obj.website,
            location: location,
            address: address,
            suburb: suburb,
            postal: postal,
            state: state,
            country: country,
            ground: obj.ground,
            manager: manager,
            secretary: secretary
        }

        _team['user'] =  _team.name.replace(" ","_").toLowerCase();

        const dataTo = {
            team: _team,
            squads: {
                female: obj.female,
                male: obj.male,
                mixed: obj.mixed
            },
            role: obj.role,
            user: FakeData.getData("yoo").id
        }


        const _that = this;
        FakeData.post("/createClubTeam.php?auth0", dataTo, {
            success(e) {
                if (e.error) {
                    FakeData.alert("A team with the email or name provided already exists!");
                } else {
                    _that.setState({ isAddingCurrentTeams: false });
                    cb.call(this)
                }
            },
            error(e) {

            }
        }, true, "Team added!", (e) => { })
    }

    getTeamNames = () => {
        const _teams = FakeData.getData("all_teams");
        const names = [];
        const rawNames = _teams.map((item, i)=>{
            return FakeData.nullify(item.rawName).toLowerCase();
        });

        const teamName = _teams.map((item, i)=>{
            return FakeData.nullify(item.name).split("(")[0].toLowerCase();
        });

        return names.concat(teamName, rawNames);
    }

    render() {
        const sports = this.getSportNames()
        const _teams = this.getTeamNames();
        const years = this.getYears()
        const { past, current } = this.props.teams;
        const { isDashboard } = this.props;
        return (
            <div className="default-view" style={{ backgroundColor: "#fff",  paddingBottom: "20px" }}>
                <div className="view-with-tabs">
                    {!isDashboard &&
                        <div className="view-with-tabs-head">
                            {
                                this.state.userTabs.map((item, i) => {
                                    return (
                                        <div key={i} className={(item === this.state.activeTab) ? "view-with-tabs-head-item active" : "view-with-tabs-head-item"} onClick={() => this.setState({ activeTab: item })}>{item}</div>
                                    )
                                })
                            }
                        </div>
                    }
                    <div className="view-with-tabs-body">
                        {(this.props.isAdmin && this.state.activeTab === "Past Teams" && !isDashboard) &&
                            <div className="my-sports-list-head">
                                {past.length > 0 &&
                                    <div className="my-sports-list-head-item manage_photos" onClick={() => {
                                        this.setState({ isManagingPast: true })
                                    }}>
                                        <span>Manage {"Teams"}</span>
                                    </div>
                                }
                            </div>
                        }

                        {(this.props.isAdmin && this.state.activeTab === "Current Teams" && !isDashboard) &&
                            <div className="my-sports-list-head">
                                <div className="my-sports-list-head-item add_album" onClick={() => this.setState({ isInvitingTeams: true })}>
                                    <span>Invites</span>
                                </div>
                                <div className="my-sports-list-head-item add_album" onClick={() => this.setState({ isAddingCurrentTeams: true })}>
                                    <span>Add Teams</span>
                                </div>

                                {current.length > 0 &&
                                    <div className="my-sports-list-head-item manage_photos" onClick={() => {
                                        this.setState({ isManagingCurrent: true })
                                    }}>
                                        <span>Manage {"Teams"}</span>
                                    </div>
                                }
                            </div>
                        }
                        {(this.state.activeTab === "Current Teams") &&
                            <SplitPane isExtended="true" active={(this.state.currentFilter === "") ? sports[0] : this.state.currentFilter} items={sports} setView={(d) => {
                                this.setState({
                                    currentFilter: d
                                });
                            }} extraContent={() => <ExtraContent />}>

                                <TeamList isCurrent={true} filter={(this.state.currentFilter === "") ? sports[0] : this.state.currentFilter} teams={current} keyFilter={"sport"} />
                            </SplitPane>
                        }
                        {(this.state.activeTab === "Past Teams") &&
                            <SplitPane isExtended="true" active={(this.state.yearFilter === "") ? years[0] : this.state.yearFilter} items={years} setView={(d) => {
                                this.setState({
                                    yearFilter: d
                                });
                            }} extraContent={() => <ExtraContent />}>
                                <TeamList isCurrent={false} filter={(this.state.yearFilter === "") ? years[0] : this.state.yearFilter} teams={past} keyFilter={"year"} />
                            </SplitPane>
                        }
                    </div>
                </div>
                <AddTeamWithSquads contentId={this.props.contentId} contentType={this.props.contentType} requireExtraContent={true} isClub={true} sports={this.props.sports} isOpen={this.state.isAddingCurrentTeams} onClose={(arr, cb) => {
                    //console.log(arr,cb)
                    //arr = [object Object]
                    if (arr === null) {
                        this.setState({
                            isAddingCurrentTeams: false
                        });
                    } else {
                        //console.log(arr)
                        this.onTeamAdd(arr, cb)
                    }

                }} />
                {current.length > 0 &&
                    <ManageTeams isPast={false} isOpen={this.state.isManagingCurrent} onClose={() => this.setState({ isManagingCurrent: false })} teams={current} />
                }
                {past.length > 0 &&
                    <ManageTeams isPast={true} isOpen={this.state.isManagingPast} onClose={() => this.setState({ isManagingPast: false })} teams={past} />
                }
                {this.state.isInvitingTeams &&
                    <ClubInvites isManage={true} fromId={this.props.contentId} invites={this.props.content.join_sent} fromType={this.props.contentType} isOpen={this.state.isInvitingTeams} onClose={() => this.setState({ isInvitingTeams: false })} />
                }
            </div>
        );
    }
}

const ExtraContent = (props) => {
    <div>
        Extra
    </div>
}

export class ClubInvites extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            tabs: ["Create", "Manage"],
            active: "Create",
            user: { id: null, name: "" },
            team: { id: null, name: "" },
            userTeams: [],
            note: "",
            error: {
                user: false,
                team: false,
                note: false
            },
            isLoadingTeams: false,
            deleteId: null
        }
    }

    componentDidMount() {
        this.setState({
            suid: Date.now(),
            tuid: Date.now() + "_team"
        });
    }

    getUserTeams(user) {
        const _that = this;
        FakeData.post("/getUserProfile.php?auth0&id=" + FakeData.getData('yoo').username + "&them=" + user.id, {}, {
            success(res) {
                _that.setState({ userTeams: res.ownTeams, isLoadingTeams: false });
            },
            error(err) {
                _that.setState({ userTeams: [], isLoadingTeams: false });
            }
        }, )
    }

    onCreate() {
        const { user, team, userTeams, note, error } = this.state;
        const _that = this;
        if (user.id === null) {
            error.user = true;
            this.setState({ error });
            return;
        }

        if (team.id === null) {
            error.team = true;
            this.setState({ error });
            return;
        }

        if (note === "") {
            error.note = true;
            this.setState({ error });
            return;
        }

        //createClubInvite.php?auth0
        const dataTo = {
            userFrom: FakeData.getData("yoo").id,
            userTo: user.id,
            toId: team.id,
            toType: "T",
            fromId: this.props.fromId,
            fromType: this.props.fromType,
            note: note
        }

        FakeData.post("/createClubInvite.php?auth0", dataTo, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Failed to create request, Please try again later!");
                } else {
                    FakeData.alert("Request created successfully!");
                    _that.setState({
                        suid: Date.now(),
                        tuid: Date.now() + "_team",
                        user: { id: null, name: "" },
                        team: { id: null, name: "" },
                        userTeams: [],
                        note: ""
                    });
                    if (_that.props.isEmbedded) {
                        _that.props.callback();
                    }
                }
            }, error(err) {
                FakeData.alert("Failed to create request, Please try again later!");
            }
        }, true, "", (r) => { })
    }

    onDelete(id) {
        //removeClubInvite.php
        const _that = this;
        const dataTo = {
            id: id
        }

        FakeData.post("/removeClubInvite.php?auth0", dataTo, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Failed to remove request, Please try again later!");
                    _that.setState({
                        deleteId: null
                    });
                } else {
                    FakeData.alert("Request removed successfully!");
                    _that.setState({
                        deleteId: null
                    });
                }
            }, error(err) {
                FakeData.alert("Failed to remove request, Please try again later!");
                _that.setState({
                    deleteId: null
                });
            }
        }, true, "", (r) => { })
    }

    render() {
        const { isOpen, invites, isEmbedded, isManage } = this.props
        const { user, team, userTeams, note, error, isLoadingTeams, tuid, suid } = this.state;
        if (isEmbedded) {
            return (
                <div style={{ width: "100%" }}>
                    <div className="add-team-with-input">
                        <span>Select a friend</span>
                        <div className="add-team-with-input-fields">
                            <ItemPicker key={suid} value={user.name} user={FakeData.getData("yoo")} error={error.user} onSelectedItem={(user) => {
                                user = user;
                                error.user = false
                                this.getUserTeams(user)
                                this.setState({ user, error, isLoadingTeams: true });
                            }} width="27.85em" isExtended={true} data={(FakeData.getData("yoo")) ? FakeData.getData("yoo").friends : []} />
                        </div>
                    </div>
                    <div className="add-team-with-input">
                        <span>Team</span>
                        <div className="add-team-with-input-fields">
                            {(isLoadingTeams) &&
                                <div>Fetching teams, please wait..</div>
                            }
                            {(!isLoadingTeams && userTeams.length === 0) &&
                                <div>Select a friend with teams under their profile</div>
                            }
                            {(!isLoadingTeams && userTeams.length > 0) &&
                                <ItemPicker key={tuid} value={team.name} user={FakeData.getData("yoo")} error={error.team} onSelectedItem={(user) => {
                                    //team = user;
                                    error.team = false
                                    this.setState({ team: user, error });
                                }} width="27.85em" isExtended={true} data={userTeams} teamsOnly={true} />
                            }
                        </div>
                    </div>
                    <div className="add-team-with-input">
                        <span>Note</span>
                        <div className="add-team-with-input-fields">
                            <textarea style={{ width: "100%", resize: "none", height: "58px" }} value={note} className={(error.note) ? "error" : ""} onChange={(e) => {
                                error.note = false;
                                this.setState({ note: e.target.value, error });
                            }} />
                        </div>
                    </div>
                    <button className="button" onClick={this.onCreate.bind(this)}>Create</button>
                </div>
            )
        }

        if (isManage) {
            return (
                <Modal isOpen={isOpen} onClose={() => this.props.onClose()}>
                    <div className="add-place" style={{ width: "600px" }}>
                        <h1>Manage Invites</h1>
                        <div style={{ width: "100%", maxHeight: "600px", overflowY: "auto" }}>

                            <div className="club-r-invites">
                                {
                                    invites.map((item, i) => {
                                        return (
                                            <div className="club-r-invite" key={item.hash}>
                                                <Avatar text={item.user.name} />
                                                <div className="club-r-invite-bd">
                                                    <span className="text">{item.note}</span>
                                                    <span className="action" onClick={() => {
                                                        this.setState({
                                                            deleteId: item.id
                                                        })
                                                    }}>Remove</span>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        {(this.state.deleteId !== null) &&
                            <ConfirmModal message="Are you sure you want to remove this request?<br/>" isOpen={(this.state.deleteId !== null) ? true : false} data={this.state.deleteId}
                                onOkay={(data) => {
                                    this.onDelete(data)
                                }}
                                onCancel={() => {
                                    this.setState({
                                        deleteId: null
                                    })
                                }} />
                        }
                    </div>
                </Modal>
            )
        }
        return (
            <Modal isOpen={isOpen} onClose={() => this.props.onClose()}>
                <div className="view-with-tabs" style={{ width: "600px" }}>
                    <div className="view-with-tabs-head">
                        {
                            this.state.tabs.map((item, i) => {
                                return (
                                    <div key={i} className={(item === this.state.active) ? "view-with-tabs-head-item active" : "view-with-tabs-head-item"} onClick={() => this.setState({ active: item })}>{item}</div>
                                )
                            })
                        }
                    </div>
                    <div className="view-with-tabs-body" style={{ minHeight: "100px", padding: "20px" }}>
                        {(this.state.active === "Create") &&
                            <div style={{ width: "100%" }}>
                                <div className="add-team-with-input">
                                    <span>Select a friend</span>
                                    <div className="add-team-with-input-fields">
                                        <ItemPicker key={suid} value={user.name} user={FakeData.getData("yoo")} error={error.user} onSelectedItem={(user) => {
                                            user = user;
                                            error.user = false
                                            this.getUserTeams(user)
                                            this.setState({ user, error, isLoadingTeams: true });
                                        }} width="27.85em" isExtended={true} data={(FakeData.getData("yoo")) ? FakeData.getData("yoo").friends : []} />
                                    </div>
                                </div>
                                <div className="add-team-with-input">
                                    <span>Team</span>
                                    <div className="add-team-with-input-fields">
                                        {(isLoadingTeams) &&
                                            <div>Fetching teams, please wait..</div>
                                        }
                                        {(!isLoadingTeams && userTeams.length === 0) &&
                                            <div>Select a friend with teams under their profile</div>
                                        }
                                        {(!isLoadingTeams && userTeams.length > 0) &&
                                            <ItemPicker key={tuid} value={team.name} user={FakeData.getData("yoo")} error={error.team} onSelectedItem={(user) => {
                                                //team = user;
                                                error.team = false
                                                this.setState({ team: user, error });
                                            }} width="27.85em" isExtended={true} data={userTeams} teamsOnly={true} />
                                        }
                                    </div>
                                </div>
                                <div className="add-team-with-input">
                                    <span>Note</span>
                                    <div className="add-team-with-input-fields">
                                        <textarea style={{ width: "100%", resize: "none", height: "58px" }} value={note} className={(error.note) ? "error" : ""} onChange={(e) => {
                                            error.note = false;
                                            this.setState({ note: e.target.value, error });
                                        }} />
                                    </div>
                                </div>
                                <button className="button" onClick={this.onCreate.bind(this)}>Create</button>
                            </div>
                        }
                        {(this.state.active === "Manage") &&
                            <div style={{ width: "100%", maxHeight: "600px", overflowY: "auto" }}>

                                <div className="club-r-invites">
                                    {
                                        invites.map((item, i) => {
                                            return (
                                                <div className="club-r-invite" key={item.hash}>
                                                    <Avatar text={item.user.name} />
                                                    <div className="club-r-invite-bd">
                                                        <span className="text">{item.note}</span>
                                                        <span className="action" onClick={() => {
                                                            this.setState({
                                                                deleteId: item.id
                                                            })
                                                        }}>Remove</span>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        }
                    </div>
                    {(this.state.deleteId !== null) &&
                        <ConfirmModal message="Are you sure you want to remove this request?<br/>" isOpen={(this.state.deleteId !== null) ? true : false} data={this.state.deleteId}
                            onOkay={(data) => {
                                this.onDelete(data)
                            }}
                            onCancel={() => {
                                this.setState({
                                    deleteId: null
                                })
                            }} />
                    }
                </div>
            </Modal>
        )
    }

}

class TeamList extends Component {
    state = {

    }

    getTeams = (val) => {
        if (this.props.isCurrent) {
            const list = []
            this.props.teams.forEach((item, i) => {
                if (item.sport.name === val) {
                    list.push(item)
                }
            })

            return list
        } else {
            if (val.toString().indexOf("before") > -1) {
                let value = val.split(" ");
                value = value[0];
                const list = []
                this.props.teams.forEach((item, i) => {
                    if (item.year <= val) {
                        list.push(item)
                    }
                })

                return list
            } else {
                const list = []
                this.props.teams.forEach((item, i) => {
                    if (item.year == val) {
                        list.push(item)
                    }
                })

                return list
            }
        }
    }

    render() {
        const teams = this.getTeams(this.props.filter)
        return (
            <div className="club-team-list">
                {
                    teams.map((item, i) => {
                        return (
                            <ClubItem key={i} isPast={false} team={item} />
                        )
                    })
                }
                {teams.length === 0 &&
                    <div className="empty-state-mini">
                        No Teams Found!
                    </div>
                }
            </div>
        );
    }
}

class ClubItem extends Component {
    state = {}
    render() {
        return (
            <div className={(this.props.isPast) ? "club-item past" : "club-item"}>
                <div className="club-item-header">
                    <div className="club-item-header-info">
                        <h2>{this.props.team.name}</h2>
                    </div>
                </div>
                <div className="club-item-body">
                    <div className="club-item-body-info">
                        <div><span>Games</span><span>{this.props.team.games}</span></div>
                        <div><span>Wins</span><span>{this.props.team.wins}</span></div>
                    </div>
                    <Link to={{ pathname: "/team/" + (this.props.team.username?this.props.team.username:this.props.team.id), search: "?squad_id=" + this.props.team.squadId + "&sInit=squad" }}>View Team Page</Link>
                </div>
            </div>
        )
    }
}

export class SplitPane extends Component {
    constructor(props) {
        super(props)
        this.state = {
            active: ""
        }
    }

    setTab(item) {
        this.props.setView(item)
    }

    render() {
        return (
            <div className="event-view-pane">
                {!this.props.isViewMode &&
                    <div className="event-view-pane-tabs" style={{ width: ((this.props.isExtended) ? "25%" : "16%") }}>
                        {
                            this.props.items.map((item, i) => {
                                return (
                                    <div key={i} className={(this.props.active === item) ? "event-view-pane-tab active" : "event-view-pane-tab"} onClick={() => this.props.setView(item)}>{(this.props.hasSuffix) ? item + " " + this.props.suffix : item}</div>
                                )
                            })
                        }
                        {this.props.extraContent}
                    </div>
                }
                <div className="event-view-pane-view">
                    {
                        this.props.children
                    }
                </div>
            </div>
        );
    }
}

class ManageTeams extends Component {
    constructor(props, context) {
        super(props, context);

        this.onClose = this.onClose.bind(this);
    }


    onClose() {
        this.props.onClose()
    }

    render() {
        const { isOpen, teams, isPast } = this.props
        return (
            <Modal isOpen={isOpen} onClose={this.onClose}>
                <div className="add-place" style={{ width: "700px" }}>
                    <h1>Manage Teams</h1>
                    <div className="club-team-manage-list">
                        {
                            FakeData.listify(teams).map((item, i) => {
                                return (
                                    <ManageTeamItem isPast={isPast} team={item} key={i} />
                                )
                            })
                        }
                    </div>
                </div>
                {teams.length === 0 &&
                    <div className="empty-state-mini" style={{ textAlign: "center" }}>No Teams Found!</div>
                }
            </Modal>
        );
    }
}

class ManageTeamItem extends Component {
    state = {
        isEditting: false,
        isArchiving: false,
        isUnarchiving: false,
        isDeleting: false,
        edit: {
            captain: this.props.team.captain || { id: null, name: "" },
            coach: this.props.team.coach || { id: null, name: "" },
            assCoach: this.props.team.assCoach || { id: null, name: "" },
        },
        error: {
            coach: false,
            captain: false,
            assCoach: false
        }
    }

    save() {
        const { edit, error } = this.state
        if (edit.coach.id === null) {
            error.coach = true;
            this.setState({ error });

            return;
        }

        if (edit.assCoach.id === null) {
            error.assCoach = true;
            this.setState({ error });

            return;
        }

        if (edit.captain.id === null) {
            error.captain = true;
            this.setState({ error });

            return;
        }

        const dataTo = {
            data: edit,
            id: this.props.team.squadId
        }

        const _that = this;

        FakeData.post("/updateSquadManagement.php?auth0", dataTo, {
            success(res) {
                _that.setState({ isEditting: false });
            },
            error(err) {

            }
        }, true, "Data Saved!", (d) => { })
    }

    archive(key) {
        const dataTo = {
            data: key,
            id: this.props.team.squadId
        }
        const _that = this;
        FakeData.post("/updateSquadArchive.php?auth0", dataTo, {
            success(res) {
                _that.setState({
                    isArchiving: false,
                    isUnarchiving: false
                });
            },
            error(err) {

            }
        }, true, "Data Saved!", (d) => { })
    }

    delete() {
        const dataTo = {
            id: this.props.team.squadId
        }
        const _that = this;
        FakeData.post("/removeSquad.php?auth0", dataTo, {
            success(res) {
                _that.setState({
                    isDeleting: false
                });
            },
            error(err) {

            }
        }, true, "Squad Removed!", (d) => { })
    }

    render() {
        const { isEditting, isDeleting, isUnarchiving, isArchiving, edit, error } = this.state
        const { team, isPast } = this.props
        return (
            <div className="club-team-manage-list-item">
                <div className="club-team-manage-list-item-header">
                    <img src={team.image} />
                    <span>{team.name}</span>
                    {!isPast &&
                        <div>
                            <span onClick={() => this.setState({ isEditting: (isEditting) ? false : true })}>Edit</span>
                            <span onClick={() => this.setState({ isArchiving: true })}>Archive</span>
                            <span onClick={() => this.setState({ isDeleting: true })}>Remove</span>
                        </div>
                    }
                    {isPast &&
                        <div>
                            <span onClick={() => this.setState({ isDeleting: true })}>Remove</span>
                            <span onClick={() => this.setState({ isUnarchiving: true })}>Unarchive</span>
                        </div>
                    }
                </div>
                {isEditting &&
                    <div className="club-team-manage-list-item-body">
                        <ItemPicker key={"c" + edit.coach.id} value={edit.coach.name} label="Coach" user={FakeData.getData("yoo")} error={error.coach} onSelectedItem={(user) => {
                            edit.coach = user;
                            error.coach = false
                            this.setState({ edit, error });
                        }} width="27.85em" isExtended={true} data={(FakeData.getData("yoo")) ? FakeData.getData("yoo").friends : []} />
                        <ItemPicker key={"ac" + edit.assCoach.id} value={edit.assCoach.name} label="Ass. Coach" user={FakeData.getData("yoo")} error={error.assCoach} onSelectedItem={(user) => {
                            edit.assCoach = user;
                            error.assCoach = false
                            this.setState({ edit, error });
                        }} width="27.85em" isExtended={true} data={(FakeData.getData("yoo")) ? FakeData.getData("yoo").friends : []} />
                        <ItemPicker key={"cp" + edit.captain.id} value={edit.captain.name} label="Captain" user={FakeData.getData("yoo")} error={error.captain} onSelectedItem={(user) => {
                            edit.captain = user;
                            error.captain = false
                            this.setState({ edit, error });
                        }} width="27.85em" isExtended={true} data={(FakeData.getData("yoo")) ? FakeData.getData("yoo").friends : []} />

                        <button onClick={this.save.bind(this)}>Save</button>
                    </div>
                }
                <ConfirmModal message="Are you sure you want to archive this squad?<br/>" isOpen={this.state.isArchiving} data={"deactive"}
                    onOkay={(data) => {
                        this.archive(data)
                    }}
                    onCancel={() => {
                        this.setState({
                            isArchiving: false
                        })
                    }} />
                <ConfirmModal message="Are you sure you want to unarchive this squad?<br/>" isOpen={this.state.isUnarchiving} data={"active"}
                    onOkay={(data) => {
                        this.archive(data)
                    }}
                    onCancel={() => {
                        this.setState({
                            isUnarchiving: false
                        })
                    }} />
                <ConfirmModal message="Are you sure you want to remove this squad?<br/>" isOpen={this.state.isDeleting} data={""}
                    onOkay={(data) => {
                        this.delete()
                    }}
                    onCancel={() => {
                        this.setState({
                            isDeleting: false
                        })
                    }} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Teams.js